// @mui
import { Container, Stack, Typography } from '@mui/material';
// components
import Page from '../../components/page';
import Form from '../../sections/form/additionalQuestions/form';
// config
import config from '../../config';

// ----------------------------------------------------------------------

const { header } = config;

const AdditionalQuestions = () => (
  <Page title={'Additional Questions'}>
    <Container>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
        <Typography variant="h4" gutterBottom>
          {header}
        </Typography>
      </Stack>

      <Form />
    </Container>
  </Page>
);

export default AdditionalQuestions;
